import React from "react";
import { makeStyles } from "@material-ui/core/styles";

import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";

import TextField from "@material-ui/core/TextField";
import Accordion from "@material-ui/core/Accordion";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";

import OptionsManagement, {
  OptionInstrumentDetails,
} from "./OptionsManagement";
import Grid from "@material-ui/core/Grid";
import InputLabel from "@material-ui/core/InputLabel";
import { Typography } from "@material-ui/core";
import { StyledRadio } from "../../../../../utils/designComponents/StyledRadio";

const OPTION_INSTRUMENTS = ["option", "future_option"];
const INSTRUMENT_OPTIONS = [
  { value: "stock", label: "stock" },
  { value: "option", label: "option" },
  { value: "future", label: "future" },
  { value: "crypto", label: "crypto" },
  { value: "forex", label: "forex" },
];

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
  },
}));

const Instrument = (props) => {
  const classes = useStyles();
  let top = props.top;
  let dispatchTop = props.dispatchTop;
  const [
    tightSpreadPctEnabled,
    setTightSpreadPctEnabled,
    tightSpreadCentsEnabled,
    setTightSpreadCentsEnabled,
    optionPriceRangeEnabled,
    setOptionPriceRangeEnabled,
    tightSpreadPct,
    dispatchTightSpreadPct,
    tightSpreadCents,
    dispatchTightSpreadCents,
    optionPriceRange,
    dispatchOptionPriceRange,
    qtyRangeEnabled,
    setQtyRangeEnabled,
    dollarRangeEnabled,
    setDollarRangeEnabled,
    qtyRange,
    dispatchQtyRange,
    dollarRange,
    dispatchDollarRange,
    hugCurrentPriceEnabled,
    setHugCurrentPriceEnabled,
    hugCurrentPrice,
    dispatchHugCurrentPrice,
    setViewOptionManagementEnabled,
    expirationDates,
    setExpirationDates,
    buyOrSellOption,
    setBuyOrSellOption,
    otm,
    setOtm,
    itm,
    setItm,
    notExpiringToday,
    setNotExpiringToday,
    showExpirationDates,
    optionChoices,
    setOptionChoices,
    optionChains,
    setOptionChains,
    symbolsUsed,
    setSymbolsUsed,
    otm1Enabled,
    setOtm1Enabled,
    otm1,
    dispatchOtm1,
    itm1Enabled,
    setItm1Enabled,
    itm1,
    dispatchItm1,
  ] = props.optionsManagement;
  let entryTactics=props.entryTactics;
  return (
    <div className={classes.root}>
      <Grid item container>
        <Grid item container xs={4}>
          <FormControl component="fieldset">
            <Grid item xs={2}>
              <FormLabel>
                <Typography style={{ fontSize: 12 }}>Instrument</Typography>
              </FormLabel>
            </Grid>
            <RadioGroup
              row
              aria-label="instrument"
              name="instrument"
              value={top.instrument === 'future_option' ? 'option' : top.instrument}
              onChange={(ev) => {
                const requestedInstrument = ev.target.value;
                const resolvedInstrument =
                  requestedInstrument === 'option' &&
                  String(top.symbol ?? '').trim().startsWith('/')
                    ? 'future_option'
                    : requestedInstrument;
                dispatchTop({ instrument: resolvedInstrument });
                const isOption = OPTION_INSTRUMENTS.includes(resolvedInstrument);
                setViewOptionManagementEnabled(isOption);
                if (resolvedInstrument === "stock") {
                  if (symbolsUsed !== 1) {
                    setSymbolsUsed(1);
                  }
                }
                let isQty = top.quantityBasis === "QUANTITY";
                let qtyBasisValue = 0;
                if (props.defaultQtyBasis !== undefined) {
                  if (isOption) {
                    if (isQty) {
                      qtyBasisValue = props.defaultQtyBasis["qtyOption"];
                    } else {
                      qtyBasisValue = props.defaultQtyBasis["dollarOption"];
                    }
                  } else {
                    if (isQty) {
                      qtyBasisValue = props.defaultQtyBasis["qtyStock"];
                    } else {
                      qtyBasisValue = props.defaultQtyBasis["dollarStock"];
                    }
                  }
                  props.dispatchMarketOrder({
                    quantityBasisValue: qtyBasisValue,
                  });
                  props.dispatchLimitOrder({
                    quantityBasisValue: qtyBasisValue,
                  });
                  props.dispatchCandleBreak({
                    quantityBasisValue: qtyBasisValue,
                  });
                }
              }}
            >
              {INSTRUMENT_OPTIONS.map(({ value, label }) => (
                <Grid item xs={4} key={value}>
                  <FormControlLabel
                    value={value}
                    control={<StyledRadio />}
                    label={<Typography style={{ fontSize: 12 }}>{label}</Typography>}
                  />
                </Grid>
              ))}
            </RadioGroup>
          </FormControl>
        </Grid>
        <Grid item xs={8}>
          {OPTION_INSTRUMENTS.includes(top.instrument) ? (
            <OptionInstrumentDetails
              top={top}
              optionsManagement={[
                buyOrSellOption,
                setBuyOrSellOption,
                itm,
                setItm,
                otm,
                setOtm,
                notExpiringToday,
                setNotExpiringToday,
              ]}
            />
          ) : (
            <></>
          )}
        </Grid>
      </Grid>
      {OPTION_INSTRUMENTS.includes(top.instrument) ? (
        <OptionsManagement
          top={top}
          optionsAvailable={props.optionsAvailable}
          dispatchTop={dispatchTop}
          optionsManagement={[
            tightSpreadPctEnabled,
            setTightSpreadPctEnabled,
            tightSpreadCentsEnabled,
            setTightSpreadCentsEnabled,
            optionPriceRangeEnabled,
            setOptionPriceRangeEnabled,
            tightSpreadPct,
            dispatchTightSpreadPct,
            tightSpreadCents,
            dispatchTightSpreadCents,
            optionPriceRange,
            dispatchOptionPriceRange,
            qtyRangeEnabled,
            setQtyRangeEnabled,
            dollarRangeEnabled,
            setDollarRangeEnabled,
            qtyRange,
            dispatchQtyRange,
            dollarRange,
            dispatchDollarRange,
            hugCurrentPriceEnabled,
            setHugCurrentPriceEnabled,
            hugCurrentPrice,
            dispatchHugCurrentPrice,
            setViewOptionManagementEnabled,
            expirationDates,
            setExpirationDates,
            setBuyOrSellOption,
            otm,
            setOtm,
            itm,
            setItm,
            notExpiringToday,
            setNotExpiringToday,
            showExpirationDates,
            optionChoices,
            setOptionChoices,
            optionChains,
            setOptionChains,
            symbolsUsed,
            setSymbolsUsed,
            otm1Enabled,
            setOtm1Enabled,
            otm1,
            dispatchOtm1,
            itm1Enabled,
            setItm1Enabled,
            itm1,
            dispatchItm1,
          ]}
          entryTactics={entryTactics}
          setOptionsAvailable={props.setOptionsAvailable}
        />
      ) : (
        <></>
      )}
    </div>
  );
};
export default Instrument;
